"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["title"];

function SvgSearch(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    $_css: props.color,
    $_css2: props.size,
    $_css3: props.size,
    $_css4: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.575 15.516l-2.88-2.88A6.897 6.897 0 008.9 2 6.896 6.896 0 002 8.9a6.896 6.896 0 0010.638 5.795l2.879 2.878a1.456 1.456 0 002.058-2.056zM8.8 3.6c2.872 0 5.2 2.325 5.2 5.198a5.16 5.16 0 01-1.524 3.676 5.163 5.163 0 01-3.677 1.523A5.197 5.197 0 013.6 8.798 5.196 5.196 0 018.8 3.6z",
    fill: "currentColor"
  }));
}

var _default = SvgSearch;
exports["default"] = _default;

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Search___StyledSvg",
  componentId: "sc-1ilttoo-0"
})(["color:", ";width:", ";height:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});
//# sourceMappingURL=Search.js.map